import { useQueueChatPauseContext } from 'hooks/useQueuePauseChatServicePanel';
import { QueueManagement } from './components/QueueManagemet';
import { LoginChatForm } from './components/LoginChatForm';
import { ContainerItems } from './styled';
import React, { useMemo } from 'react';

const PauseServicePanel = () => {
  const { queuesChatLoggedValues } = useQueueChatPauseContext();
  const inQueues = queuesChatLoggedValues.length > 0;

  const agentName = useMemo(() => localStorage.getItem('name'), []);

  /** Caso o atendente esteja em alguma fila de chat
   *  Será exibido a tela de genrencimaneto de fila.
   *  Caso não esteja em nenhuma fila de chat
   *  Será exibido a tela de login em fila de chat
   */

  if (inQueues) {
    return <QueueManagement />;
  }

  return (
    <ContainerItems>
      <LoginChatForm agentName={agentName} />
    </ContainerItems>
  );
};

export default PauseServicePanel;
